import dynamic from 'next/dynamic';
import { useAtomValue } from 'jotai';

import { isQuickSettingsOpenAtom } from '@/atoms/quick-settings';

const QuickSettings = dynamic(() =>
	import('../quick-settings').then(m => m.QuickSettings)
);

export const QuickSettingsLoader = () => {
	const isShow = useAtomValue(isQuickSettingsOpenAtom);

	return isShow ? <QuickSettings /> : null;
};